import { render, staticRenderFns } from "./AreaEmbargadaPiaui.vue?vue&type=template&id=51f19021&scoped=true&lang=pug"
import script from "./AreaEmbargadaPiaui.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaPiaui.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargadaPiaui.vue?vue&type=style&index=0&id=51f19021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f19021",
  null
  
)

export default component.exports